import PropTypes from 'prop-types';

const userShape = PropTypes.shape({
  avatarColor: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
});

export default userShape;
